/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionTreeView = Backbone.View.extend({
    initialize: function() {
      _.bindAll(this, "render");
      var self = this;

      this.model.on("change", this.render);

      // Listen for clicks on the category nodes and toggle their visibilty
      $(".download-indicator-lists-container").on(
        "click",
        "li[data-top-category] .download-indicator-list-link",
        function(e) {
          var $catNode = $(this).closest("li[data-top-category]");
          var id = $catNode.data("category-id");

          var selectedIds = self.model.get("selectedCategories");
          var newIds;
          if (_.has(selectedIds, id)) {
            // update the model
            newIds = _.omit(selectedIds, "" + id); // _.omit seems to be broken for int keys, so stringify the id
            self.model.set("selectedCategories", newIds);
          }
          else {
            // update the model
            newIds = {};
            newIds[id] = true;
            _.extend(newIds, selectedIds);
            self.model.set("selectedCategories", newIds);
          }
        }
      );

      // Listen for a click on the "expand/collapse" button and update the model
      $(".indicator-tree-toggle").on("click", function() {
        var $topLevelCategories = $("li[data-top-category]"),
          ids = self.model.get("selectedCategories"),
          newIds = {};

        // if the number of selectedCategories in the model is equal to the
        // number of li's in the view, collapse; otherwise, expand
        if ($topLevelCategories.length === _.size(ids)) {
          // collapse
          self.model.set("selectedCategories", { 0: true });
        }
        else {
          $topLevelCategories.each(function() {
            newIds[$(this).data("category-id")] = true;
          });
          self.model.set("selectedCategories", newIds);
        }
      });
    },

    render: function() {
      // The tree html is rendered on the server side, so just
      // hide or show the indicator & category nodes that correspond with
      // the currently selected location type
      var self = this;
      var elementsToHide = [];
      var elementsToShow = [];
      var $topLevelCategories = $("li[data-top-category]");

      function isHidden($element) {
        // The :visible/:hidden pseudoselectors are affected by parent visibility, but
        // for the purposes of deciding what to show, we need to know if the elements
        // would be hidden even if the parent element is not.
        // Test this by checking for CSS styles.
        return (
          $element
            .stop(true, true) // Finish any pending animations immediately, or we can't be sure
            .css("display") === "none"
        ); // In this case, we need only look at "display"
      }

      // Anything with a "data-loctype-ids" attribute is potentially hidden
      $.merge(
        elementsToShow,
        $("[data-loctype-ids]").filter(function() {
          return isHidden($(this));
        })
      );

      $(elementsToHide).slideUp(700);
      $(elementsToShow).slideDown(700);

      // Open / close the top level tree nodes as necessary
      var selectedIds = self.model.get("selectedCategories");
      $topLevelCategories.each(function() {
        var catId = $(this).data("category-id");
        var $container = $(".download-indicator-list-toggle-container", this);
        var catIsSelected = _.has(selectedIds, catId);
        if (catIsSelected && isHidden($container)) {
          $container.slideDown();
          $(".download-indicator-list-link", this).addClass("active");
        }
        else if (!catIsSelected && !isHidden($container)) {
          $container.slideUp();
          $(".download-indicator-list-link", this).removeClass("active");
        }
      });

      $(".indicator-tree-toggle").text(
        _.size(selectedIds) === $topLevelCategories.length
          ? "Collapse All"
          : "Expand All"
      );
    }
  });
})(jQuery, _);
